/* eslint-disable prettier/prettier */
// import { v4 as uuidV4 } from "uuid";

export const QUERY = {
  allMasterDescriptions: `
  query MyQuery {
    allMasterDescriptions(condition: { isActive: true }) {
      nodes {
        value:id
        label:descriptionName
        descriptionName
        isActive
        createdAt
        createdBy
        updatedAt
        updatedBy
        id
      }
    }
  }
    `,
  addMasterDescriptions: ({ descriptionName }) => `
  mutation{
    createMasterDescription(input:{
      masterDescription:{
        descriptionName:"${descriptionName}",
        isActive:true,
        createdAt: "${new Date().toISOString()}"
        updatedAt: "${new Date().toISOString()}"
      }
    }){
      clientMutationId
    }
  }
    `,
  updateMasterDescriptions: ({ id, isActive = true, descriptionName }) => `
  mutation{
    updateMasterDescriptionById(input:{
      masterDescriptionPatch:{
        ${descriptionName?`descriptionName:"${descriptionName}"`:""}
        isActive: ${isActive}
        updatedAt: "${new Date().toISOString()}"
      },
      id :${id}
    }){
      clientMutationId
    }
  }`
};